import React, { createContext, useContext } from 'react';

import { useDispatch, useLogger, useSelector } from '~Hooks';
import LoginModal from '~Scenes/Tables/Components/LoginModal';
import { StaffIDState } from '~reducers';

interface ContextType {
  authedStaff: StaffIDState;
  logoutStaff: () => void;
}

interface ProviderProps {
  children: React.ReactNode;
}

const Context = createContext<ContextType>({} as ContextType);

export const useStaffContext = () => useContext(Context);

export default function StaffContextProvider({ children }: ProviderProps) {
  const logger = useLogger('handy');
  const dispatch = useDispatch();
  const hasStaffCodes = useSelector((state) => !!state.companyStaff?.staffs?.length);
  const authedStaff = useSelector((state) => state.staff);

  /**
   * Logs out a staff by dispatching event
   * Also resets the pageState to avoid unauthorised access to pages
   */
  const logoutStaff = () => {
    logger.info('Staff logged out.', {
      staff: authedStaff,
    });
    dispatch({
      type: 'POS_STAFF_LOGOUT',
    });
  };

  const contextValue = {
    authedStaff,
    logoutStaff,
  };

  return (
    <Context.Provider value={contextValue}>
      {hasStaffCodes && !authedStaff && <LoginModal />}
      {children}
    </Context.Provider>
  );
}
